import { render, staticRenderFns } from "./UguList.vue?vue&type=template&id=aadf4624&"
import script from "./UguList.vue?vue&type=script&lang=js&"
export * from "./UguList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports